import React, { lazy, Suspense } from 'react';
import { App } from './App';
import { LoadingModal } from '../LoadingModal/LoadingModal';
import { ModalWrapper } from '../ModalRenderer/ModalWrapper';
import { useRenderControl } from '../../context/InstallerRenderControlContext';
const LazyLegacyInstallApp = /*#__PURE__*/lazy(() => import('../LegacyInstaller/LegacyInstallApp'));
export const AppWrapper = () => {
  const {
    shouldUseOldInstaller
  } = useRenderControl();
  if (shouldUseOldInstaller) {
    return /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement(ModalWrapper, null, /*#__PURE__*/React.createElement(LoadingModal, null))
    }, /*#__PURE__*/React.createElement(LazyLegacyInstallApp, null));
  }
  return /*#__PURE__*/React.createElement(App, null);
};
//# sourceMappingURL=AppWrapper.js.map